import store from '../store'
export function pathDispose(paths,cy) {
    var list = paths.map(item=>{
        if(cy == 1){
            return store.getters.imageUrl + item
        }else{
            return store.getters.imageOss + item
        }
        
    })
    return list
} 